'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Bleed": "Polaris-Bleed"
};

exports.default = styles;
